<template>
  <div v-if="viewMember != null" class="UserPage">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="bgContent">
        <section class="user-bg">
          <div class="user-banner">
            <div class="hd" @click="onClickRight">
              <div class="avatar">
                <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  round
                  :src="viewMember.Member.HeadPic"
                />
              </div>
              <div class="name">{{ viewMember.Member.NickName }}</div>
            </div>
            <div class="bd">
              <!-- 已登录 -->
              <div v-if="currentToken.isLogin && viewMember != null">
                <!-- <p class="account">账号:{{memberInfo.No}}</p>
                <p>孝爱币:{{memberInfo.HasCoin}}</p>-->
                <!-- <p class="signbox">
              <span class="hlight">签到</span>获得10孝爱币
                </p>-->
                <p class="info">
                  <span>会员ID：{{ viewMember.Member.SerialNumber }}</span>
                  <span @click="copyNumber" class="clipBtn">复制</span>
                </p>

                <div v-if="viewMember.AgentLevel != null" class="grade-box">
                  <img :src="viewMember.AgentLevel.Icon" alt class="zuanIcon" />
                  {{ viewMember.AgentLevel.AgentLevelName }}
                </div>

                <div
                  v-if="viewMember.DistributionLevel != null"
                  class="grade-box"
                >
                  <img
                    :src="viewMember.DistributionLevel.Icon"
                    alt
                    class="zuanIcon"
                  />
                  {{ viewMember.DistributionLevel.DistributionLevelName }}
                  {{
                    viewMember.Member.DistributionLevel2Name != "" &&
                    viewMember.Member.DistributionLevel2Name != null &&
                    viewMember.Member.DistributionLevel2Name != "普通会员"
                      ? "（" + viewMember.Member.DistributionLevel2Name + "）"
                      : ""
                  }}
                </div>
                <p class="info">孝爱币：{{ viewMember.Member.HasCoin }}个</p>
                <p
                  v-if="viewMember.Referee != '' && viewMember.Referee != null"
                  class="info"
                >
                  推荐人：{{
                    viewMember.Referee + "(" + viewMember.ParentId + ")"
                  }}
                </p>
                <p v-if="viewMember.Member.XiaoAiIntegral != null" class="info">
                  孝心：{{ viewMember.Member.XiaoAiIntegral }}
                </p>
              </div>
              <!-- 未登录 -->
              <div v-else>
                <router-link to="/Login" class="account">登录</router-link>
              </div>
            </div>
          </div>
          <div class="prices">
            <div class="every-data" @click="goPage('withdrawal')">
              <div class="every-data-top">
                {{ viewMember.Member.HasCash }}
              </div>
              <div class="every-data-bottom">账户余额(元)</div>
            </div>
            <div class="every-data" @click="goPage('commission')">
              <div class="every-data-top">
                {{ viewMember.Member.TotalPrice }}
              </div>
              <div class="every-data-bottom">累计收益(元)</div>
            </div>
            <div class="every-data" @click="goPage('memberDetail2s')">
              <div class="every-data-top">
                {{ viewMember.Member.PjPrice }}
              </div>
              <div class="every-data-bottom">平级奖金(元)</div>
            </div>
            <div
              v-if="viewMember.AgentLevel != null"
              class="every-data"
              @click="goPage('memberTeamDetails')"
            >
              <div class="every-data-top">
                {{ viewMember.Member.TeamPrice }}
              </div>
              <div class="every-data-bottom">团队奖(元)</div>
            </div>
          </div>
        </section>

        <section :border="false" class="my-panel">
          <div class="thead">
            <div class="service-title">会员服务</div>
          </div>
          <van-grid :gutter="10" clickable :border="false" :column-num="3">
            <van-grid-item to="/MemberDetails">
              <img src="@/assets/images/me/cate-vip.png" class="grid-icon" />
              <div class="grid-text">开通会员</div>
            </van-grid-item>
            <!-- <van-grid-item v-if="levelType > 0" @click="gotoLevelView">
              <img src="@/assets/images/me/cate-teame.png" class="grid-icon" />
              <div class="grid-text">我的团队</div>
            </van-grid-item>
            <van-grid-item v-if="levelType > 0" to="/MyWallet">
              <img src="@/assets/images/me/cate-wallet.png" class="grid-icon" />
              <div class="grid-text">我的钱包</div>
            </van-grid-item>
            <van-grid-item
              v-if="levelType > 0"
              :to="'/CommissionDetails?levelTid=' + levelType"
            >
              <img src="@/assets/images/me/cate-cash.png" class="grid-icon" />
              <div class="grid-text">佣金明细</div>
            </van-grid-item> -->
            <van-grid-item v-if="levelType > 0" to="/QrcodePage">
              <img src="@/assets/images/me/cate-qrcode.png" class="grid-icon" />
              <div class="grid-text">我的推广码</div>
            </van-grid-item>
            <van-grid-item to="/OrderList">
              <img src="@/assets/images/me/cate-order.png" class="grid-icon" />
              <div class="grid-text">我的订单</div>
            </van-grid-item>
            <!-- <van-grid-item v-if="levelType == 2" to="/CommissionGiveDetails">
              <img src="@/assets/images/me/cate-give.png" class="grid-icon" />
              <div class="grid-text">赠送会员</div>
            </van-grid-item> -->

            <van-grid-item to="/memberList">
              <img src="@/assets/images/me/service1.png" class="grid-icon" />
              <div class="grid-text">我的用户</div>
            </van-grid-item>

            <van-grid-item to="/accountManage">
              <img src="@/assets/images/me/service2.png" class="grid-icon" />
              <div class="grid-text">账户管理</div>
            </van-grid-item>
            <van-grid-item to="/commission">
              <img src="@/assets/images/me/service3.png" class="grid-icon" />
              <div class="grid-text">佣金记录</div>
            </van-grid-item>

            <van-grid-item to="/withdrawal">
              <img src="@/assets/images/me/service4.png" class="grid-icon" />
              <div class="grid-text">我要提现</div>
            </van-grid-item>

            <van-grid-item to="/AddressManage">
              <img src="@/assets/images/me/service6.png" class="grid-icon" />
              <div class="grid-text">地址管理</div>
            </van-grid-item>

            <van-grid-item to="/jifenDetails">
              <img src="@/assets/images/quan02.png" class="grid-icon" />
              <div class="grid-text">积分明细</div>
            </van-grid-item>
            <van-grid-item to="/jifenGiveForm">
              <img src="@/assets/images/quan03.png" class="grid-icon" />
              <div class="grid-text">积分转赠</div>
            </van-grid-item>
            <van-grid-item to="/yeGiveForm">
              <img src="@/assets/images/change.png" class="grid-icon" />
              <div class="grid-text">转出转入</div>
            </van-grid-item>
            <van-grid-item to="/signIn">
              <img src="@/assets/images/calendar.png" class="grid-icon" />
              <div class="grid-text">每日签到</div>
            </van-grid-item>
          </van-grid>
        </section>

        <section :border="false" class="my-panel">
          <van-cell center title="在线充值" to="/Recharge" is-link />
          <van-cell
            center
            title="好友转账"
            to="/Transfer"
            is-link
            value="仅限孝爱币"
            value-class="t12"
          />
          <!-- <van-cell center title="代祭预约订单" to="/BookingOrderList" is-link /> -->
          <van-cell center title="系统设置" to="/Settings" is-link />
          <!-- <van-cell center title="在线升级" is-link value="已是最新版本 1.0.1版" value-class="t12" /> -->
        </section>

        <section :border="false" class="my-panel">
          <van-cell center title="消息公告" to="/MessageList" is-link />
          <!-- <van-cell center title="关于我们" to="/About" is-link /> -->
          <van-cell center title="意见反馈" to="/Feedback" is-link />
        </section>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Toast } from "vant";
import { mapGetters } from "vuex";
import common from "../../tools/common.js";
import auth from "../../tools/auth.js";

export default {
  data() {
    return {
      refreshing: false,
      isRefresh: false,
      levelType: 0, //0:普通会员,1:代理商：2:合伙人
    };
  },
  computed: {
    ...mapGetters(["currentToken", "viewMember"]),
  },
  components: {},
  mounted() {},
  methods: {
    init() {
      var that = this;
      var params = {
        type: "GetMemberIndex",
      };
      that.$weixin.AutoWeixinAuthorize(that);
      this.GetMemberState(() => {
        auth.getIsPhoneAuth(this).then((res) => {
          // console.log(res,"getIsPhoneAuth");
          if (!res) {
            that.$router.replace({
              path: "AuthPhoneUser?ReturnUrl=" + this.$route.fullPath,
            });
          } else {
            that.$store.dispatch(params).then(
              (res) => {
                if (that.refreshing) {
                  that.refreshing = false;
                }
                if (res.AgentLevel != null) {
                  this.levelType = 2;
                } else if (res.DistributionLevel != null) {
                  this.levelType = 1;
                } else {
                  this.levelType = 0;
                }
              },
              (err) => {
                console.log(err);
                //common.errorLocation(that, err);
              }
            );
          }
        });
      });
    },
    // getIsPhoneAuth(callBack) {
    //   this.$store
    //     .dispatch({
    //       type: "IsPhoneAuth",
    //     })
    //     .then((res) => {
    //       if (callBack) {
    //         callBack(res);
    //       }
    //     });
    // },
    GetMemberState(callBack) {
      this.$store
        .dispatch({
          type: "GetMemberState",
        })
        .then((res) => {
          // console.log(res, "GetMemberState");
          if (res.Result.IsSuccess) {
            callBack();
          } else {
            this.$store.dispatch({ type: "Logout" }).then((res) => {
              this.$router.query("/login?ReturnUrl=/user");
            });
          }
        });
    },
    onClickRight() {
      this.$router.push("/UserEdit");
    },
    copyNumber() {
      // console.log(this.viewMember.Member.SerialNumber);
      this.$copyText(this.viewMember.Member.SerialNumber).then(
        function(e) {
          //alert('Copied')
          Toast("复制成功！");
          console.log(e);
        },
        function(e) {
          //alert('Can not copy')
          Toast("复制权限不够！");
          console.log(e);
        }
      );
    },
    onRefresh() {
      this.refreshing = true;
      this.init();
    },
    gotoLevelView() {
      if (this.levelType == 2) {
        this.$router.push("/TeamList");
      } else {
        this.$router.push(
          "/TeamIndex?MemberId=" + this.viewMember.Member.MemberID
        );
      }
    },
    goPage(page) {
      if (page == "memberDetail2s") {
        this.$router.push(
          page + "?MemberId=" + this.viewMember.Member.MemberID
        );
      } else {
        this.$router.push(page);
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log(from);
    if (from.name == "Login" || from.name == "Recharge") {
      to.meta.refresh = true;
    }
    next();
  },
  activated() {
    // console.log("activated")
    if (this.$route.meta.refresh) {
      this.init();
      this.$route.meta.refresh = false;
    }
  },
  created() {
    // console.log("created")
    var that = this;
    that.init();
    // that.$weixin.AutoWeixinAuthorize(that);
    // auth.getIsPhoneAuth(this).then((res) => {
    //   // console.log(res,"getIsPhoneAuth");
    //   if (!res) {
    //     that.$router.replace({
    //       path: "AuthPhoneUser?ReturnUrl=" + this.$route.fullPath,
    //     });
    //   } else {
    //     that.init();
    //   }
    // });
  },
};
</script>

<style lang="less" scoped>
.UserPage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 50px;
  background-color: #f2f2f2;
}
.bgContent {
  // background: url("~@/assets/images/me/my-bg.jpg") no-repeat top center;
  // background-size: 100% auto;
  // background-attachment: scroll;
}

.user-bg {
  background: url("~@/assets/images/me/my-bg.jpg") repeat top center;
  background-size: 100% auto;
  background-attachment: scroll;
  background-color: #24a378;
  height: auto;
  min-height: 285px;
}

.user-banner {
  padding: 15px;
  display: flex;
  align-items: flex-start;
}
.user-banner > .hd {
  overflow: hidden;
  width: 96px;
  margin-right: 10px;
}
.user-banner > .hd > .avatar {
  width: 86px;
  height: 86px;
  border: 3px solid rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  margin: 0 auto;
}
.user-banner > .hd > .name {
  font-size: 14px;
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 4px;
  text-align: center;
}
.user-banner > .bd {
  flex: 1;
  overflow: hidden;
  padding: 0 10px;
}
.user-banner > .bd .account {
  font-size: 16px;
  color: #fff;
  margin-bottom: 10px;
  margin-top: 20px;
  display: inline-block;
}
.user-banner > .bd .signbox {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
}
.user-banner > .bd .signbox .hlight {
  margin-right: 15px;
  font-size: 15px;
}
.user-banner > .bd .info {
  margin-top: 4px;
  font-size: 14px;
  color: #fff;
}
.clipBtn {
  font-size: 12px;
  color: #fff;
  background-color: orange;
  height: 18px;
  line-height: 18px;
  padding: 0 10px;
  border-radius: 99px;
  display: inline-block;
  margin-left: 10px;
  transform: scale(0.9);
}
.grade-box {
  background-color: rgba(0, 0, 0, 0.4);
  padding: 0 10px;
  height: 28px;
  display: flex;
  align-items: center;
  border-radius: 999px;
  max-width: 220px;
  font-size: 13px;
  color: #fff;
  transform: scale(0.9);
  margin-top: 4px;
  margin-left: -12px;
}
.grade-box .zuanIcon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 12px;
}
.service-title {
  font-size: 15px;
  padding: 10px 16px;
}
.my-panel {
  margin: 10px;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  top: -40px;
}
.my-panel .thead {
  border-bottom: 1px solid #eee;
}
.grid-icon {
  width: 21px;
  height: 21px;
  object-fit: contain;
  display: block;
}
.grid-text {
  font-size: 13px;
  color: #444;
  text-align: center;
  margin-top: 4px;
}
.my-panel .van-cell {
  background-color: transparent !important;
}
.my-panel .van-cell--clickable:active {
  background-color: #f6f6f6 !important;
}

.prices {
  display: flex;
  flex-flow: row;
  justify-content: space-around;
  .every-data {
    text-align: center;
    color: white;
    .every-data-top {
      font-size: 17px;
      color: #fff;
      font-weight: 700;
    }
    .every-data-bottom {
      font-weight: 700;
      font-size: 12.999px;
    }
  }
}
</style>
